import React from "react";
import Controller from "./Routing/Controller";

function App() {
    return (
        <Controller/>
    )
}

export default App;